import React from "react";
import PropTypes from "prop-types";
import { TableContainer, Col, Row, Title, Company, Designation, ContentWrapper } from "./style";
import { endpoint } from "../../config/app.config";
import { getCookie, clearCookie, setParentDomainCookie } from "../../utils/cookies";

const { token, reset, sub, user } = getCookie()

const TableComponent = React.memo((props) => {
  const { data, columnNumber } = props;
  const dataLength = data ? data.length : 0;

  const handleLinkedinClick = (event, linkedinUrl) => {
    event.preventDefault();
    window.open(`/redirect?url=${linkedinUrl}`);
  }

  const hasBorder = (dataLength, index) => {
    if (dataLength > columnNumber) {
      if ((index + 1) === dataLength) {
        return true;
      } else if ( (index+1) % columnNumber === 0) {
        return true;
      } else {
        return false
      }
    } else {
      if ((index + 1) === dataLength) {
        return true;
      } else {
        return false
      }
    }
  }

  return (
    <section>
      {dataLength > 0 && <TableContainer>
        <Row cols={dataLength}>
          {data.map((item, index) => {
              clearCookie()
              const imgSrc = `${endpoint}/api/assets/images?id=${item.image}`
              const img = new Image()
              img.src = imgSrc
              img.onload = () => {
                setParentDomainCookie(token, reset, sub, user)
              }
            return (
            <Col count={dataLength} noborder={hasBorder(dataLength, index)} key={index}>
              <img src={imgSrc} alt={`${item.name} - image`}></img>
              <ContentWrapper noborder={hasBorder(dataLength, index)}>
                {item.linkedinUrl
                  ? <Title className="social-media-link" href={item.linkedinUrl.trim()} onClick={(event) => handleLinkedinClick(event, item.linkedinUrl.trim())}>{item.name}</Title>
                  : <Title as="span">{item.name}</Title>}
                <Designation>{item.designation}</Designation>
                <Company>{item.company}</Company>
              </ContentWrapper>
            </Col>
          ) })}
        </Row>
      </TableContainer>}
    </section>
  );
});

TableComponent.propTypes = {
  data: PropTypes.array,
  columnNumber:PropTypes.number
}

export default TableComponent;